export default __webpack_public_path__ + "static/primaryfelicitation1-43b6ad277d6b3460901c830055998479.png";